import React from 'react';
import TextField from '@material-ui/core/TextField';
import './login.css';
import { Link, useHistory } from 'react-router-dom';

import { auth } from '../firebase';
function Login() {
  var email = '';
  var password = '';
  const history = useHistory();
  const SignIn = (e) => {
    e.preventDefault();
    //some fansy dirbase login ..............
    auth
      .signInWithEmailAndPassword(email, password)
      .then((auth) => {
        history.push('/');
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  const register = (e) => {
    e.preventDefault();
    //---------------so dome firbase stuff ................
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((auth) => {
        console.log(auth);
        if (auth) {
          history.push('/');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="login">
      <Link to="/">
        <img
          className="login__logo "
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png"
          alt=""
        />
      </Link>

      <div className="login__container">
        <form>
          <div className="login__container_form_input">
            <h5>Email</h5>
            <TextField
              type="text"
              name="email"
              size="small"
              color="secondary"
              autoFocus={true}
              fullWidth={true}
              //   value={email}
              onChange={(e) => (email = e.target.value)}
              // label="Email"
              variant="outlined"
            />
          </div>
          <div className="login__container_form_input">
            <h5>Password</h5>
            <TextField
              type="password"
              name="Password"
              size="small"
              color="secondary"
              autoFocus={true}
              fullWidth={true}
              //   value={password}
              onChange={(e) => (password = e.target.value)}
              variant="outlined"
              // label="Password"
            />
          </div>
          <div className="login__container_form_input">
            <button className="login__signInButton" onClick={SignIn}>
              Sign In
            </button>
          </div>
        </form>
        <p>
          By signing-in you agree to the AMAZON FAKE CLONE Conditions of Use &
          Sale. Please see our Privacy Notice, our Cookies Notice and our
          Interest-Based Ads Notice.
        </p>
        <button
          type="submit"
          className="login__registerButton"
          onClick={register}
        >
          Create your Amazon Account
        </button>
      </div>
    </div>
  );
}

export default Login;
